import type { KnowledgeDatabaseInfo } from '../KnowledgeDatabase/knowledgeDatabases'
import { buildKnowledgeDatabasePath, paths } from '../../paths'
import { knowledgeDatabases } from '../KnowledgeDatabase/knowledgeDatabases'

export interface KnowledgeDatabaseMenuEntry {
  label: string
  description: string
  tenantId: string
}

function toMenuEntry(database: KnowledgeDatabaseInfo): KnowledgeDatabaseMenuEntry {
  return { label: database.name, description: database.description, tenantId: database.tenantId }
}

export const knowledgeDatabaseEntries: KnowledgeDatabaseMenuEntry[] = knowledgeDatabases.map(toMenuEntry)

export function getBookingSearchPath() {
  return paths.home
}

export function getKnowledgeDatabaseEntryPath(entry: KnowledgeDatabaseMenuEntry) {
  return buildKnowledgeDatabasePath(entry.tenantId)
}

export type TopNavItem = 'bookingSearch' | 'knowledgeDatabase'

export function getActiveTopNavItem(pathname: string): TopNavItem | undefined {
  if (pathname === paths.home) {
    return 'bookingSearch'
  }
  if (pathname.startsWith('/knowledgedatabase')) {
    return 'knowledgeDatabase'
  }
  return undefined
}

export function getActiveKnowledgeDatabaseTenantId(pathname: string): string | undefined {
  const match = /^\/knowledgedatabase\/([^/]+)/.exec(pathname)
  if (!match) {
    return undefined
  }
  try {
    return decodeURIComponent(match[1])
  }
  catch {
    return undefined
  }
}
